import { render, staticRenderFns } from "./TaskTemplateListing.vue?vue&type=template&id=4de5181f&"
import script from "./TaskTemplateListing.vue?vue&type=script&lang=js&"
export * from "./TaskTemplateListing.vue?vue&type=script&lang=js&"
import style0 from "./TaskTemplateListing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports